import { EnvironmentProviders, Optional, makeEnvironmentProviders } from '@angular/core';
import {GEOLOCATION_SERVICE_TOKEN, GeolocationService} from "./geolocation.service";

export function provideGeolocation(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: GEOLOCATION_SERVICE_TOKEN,
      useFactory: (service: GeolocationService | null) => service,
      deps: [[new Optional(), GeolocationService]]
    }
  ]);
}
